module.exports = __webpack_public_path__ + "images/emoji/eggplant.3175a5173728fbf223b8.png";